export default __webpack_public_path__ + "css/gateway-editor.css";